<script setup>
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import BackgroundField from '@/components/BackgroundField.vue'
import CookieNotice from '@/components/CookieNotice.vue'
import AnalyticsInjector from '@/components/AnalyticsInjector.vue'
import Toast from '@/components/Toast.vue'

const route = useRoute()
const isAdmin = computed(() => route.path.startsWith('/admin'))
</script>

<template>
  <div class="app-shell">
    <RouterView v-if="isAdmin" />
    <template v-else>
      <BackgroundField />
      <AppHeader />
      <main class="app-main">
        <RouterView />
      </main>
      <AppFooter />
      <CookieNotice />
      <AnalyticsInjector />
      <Toast />
    </template>
  </div>
</template>

<style>
.app-shell {
  min-height: 100dvh;
  background: transparent;
  color: var(--ink);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}
.app-main { flex: 1; }
</style>
